export default __webpack_public_path__ + "static/media/5.1bfcf9db.png";